/* QUILTZA tahminli arama: Shopify Predictive Search + Section Rendering, debounce, istek iptali, combobox klavye. */
(function () {
  if (customElements.get('qz-predictive-search')) return;
  var DEBOUNCE = 250;
  var MIN = 2;

  customElements.define('qz-predictive-search', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.input = this.querySelector('[data-qz-ps-input]');
      this.results = this.querySelector('[data-qz-ps-results]');
      this.list = this.querySelector('[data-qz-ps-list]');
      this.status = this.querySelector('[data-qz-ps-status]');
      this.all = this.querySelector('[data-qz-ps-all]');
      this.panel = this.closest('[data-qz-search]');
      this.active = -1;
      this.timer = null;
      this.controller = null;
      this.reqId = 0;
      var self = this;
      this.input.addEventListener('input', function () {
        clearTimeout(self.timer);
        self.timer = setTimeout(function () { self.search(self.input.value.trim()); }, DEBOUNCE);
      });
      this.input.addEventListener('keydown', this.onKey.bind(this));
      this.addEventListener('keydown', this.trap.bind(this));
      if (this.panel && 'MutationObserver' in window) {
        new MutationObserver(function () { if (self.panel.hidden) self.reset(); }).observe(this.panel, { attributes: true, attributeFilter: ['hidden'] });
      }
    }

    reset() {
      clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
      this.setExpanded(false);
      this.results.hidden = true;
      this.list.innerHTML = '';
      this.status.textContent = '';
      this.all.hidden = true;
      this.active = -1;
    }
    setExpanded(on) { this.input.setAttribute('aria-expanded', on ? 'true' : 'false'); if (!on) this.input.removeAttribute('aria-activedescendant'); }

    search(q) {
      if (q.length < MIN) { this.reset(); return; }
      if (this.controller) this.controller.abort();
      this.controller = 'AbortController' in window ? new AbortController() : null;
      var id = ++this.reqId;
      var self = this;
      this.results.hidden = false;
      this.status.textContent = this.dataset.loading || '';
      var url = this.dataset.url + '?q=' + encodeURIComponent(q) +
        '&section_id=qz-predictive-results&resources[type]=product&resources[limit]=' + (this.dataset.limit || 8) +
        '&resources[options][unavailable_products]=last';
      fetch(url, this.controller ? { signal: this.controller.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (text) {
          if (id !== self.reqId) return; /* geç dönen eski istek yenisini ezmez */
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var items = doc.querySelectorAll('[data-qz-ps-items] > li');
          self.list.innerHTML = '';
          Array.prototype.forEach.call(items, function (li) { self.list.appendChild(li); });
          self.active = -1;
          self.input.removeAttribute('aria-activedescendant');
          self.all.href = self.dataset.searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last&type=product';
          if (items.length) {
            self.status.textContent = '';
            self.all.hidden = false;
            self.setExpanded(true);
          } else {
            self.status.textContent = self.dataset.empty || '';
            self.all.hidden = true;
            self.setExpanded(false);
          }
        })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          if (id === self.reqId) { self.status.textContent = self.dataset.empty || ''; self.setExpanded(false); }
        });
    }

    options() { return Array.prototype.slice.call(this.list.querySelectorAll('[role="option"]')); }
    move(dir) {
      var opts = this.options();
      if (!opts.length) return;
      this.active = (this.active + dir + opts.length) % opts.length;
      var input = this.input;
      opts.forEach(function (o, i) { o.setAttribute('aria-selected', i === this.active ? 'true' : 'false'); }, this);
      var cur = opts[this.active];
      input.setAttribute('aria-activedescendant', cur.id);
      cur.scrollIntoView({ block: 'nearest' });
    }
    onKey(e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); this.move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); this.move(-1); }
      else if (e.key === 'Enter' && this.active > -1) {
        var opt = this.options()[this.active];
        var a = opt && opt.querySelector('a');
        if (a) { e.preventDefault(); window.location.href = a.href; }
      }
    }
    trap(e) {
      if (e.key !== 'Tab' || !this.panel || this.panel.hidden) return;
      var nodes = Array.prototype.filter.call(
        this.querySelectorAll('input:not([type="hidden"]), button, a[href]:not([hidden])'),
        function (n) { return n.offsetParent !== null && !n.closest('[hidden]'); }
      );
      if (!nodes.length) return;
      var first = nodes[0], last = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
